import { MatchCardSubscription } from '../types';
import { isValidMatchCardSubscription } from './typeguards';
import { CreateMatchCardInputSchema } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { IMatchCardDataBlock } from '@sky-it-livedata/livedata-sports-design-system';

export default (obj: MatchCardSubscription): IMatchCardDataBlock=> {
  if (isValidMatchCardSubscription(obj)) {
    CreateMatchCardInputSchema().parse(obj.data.onUpdateMatchCardByMatchId, {reportInput: true});
    const { competition, ...matchCard } = obj.data.onUpdateMatchCardByMatchId;

    const validatedMatch = {
      ...matchCard,
      customCompetitionName: competition!.name,
      id: competition!.id,
      link: matchCard.matchDetailUrl,
    } as IMatchCardDataBlock['match'];

    return {
      match: validatedMatch,
      isLoading: false,
    };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in MatchCardSubscription object',
      data: obj
    });
  }
};



